function a(l, e, t) {
  const f = (t == null ? void 0 : t.trim) ?? !0, u = (t == null ? void 0 : t.ellipsis) ?? "...";
  if (typeof l != "string")
    return "";
  let r = l;
  return e < 0 || Math.max(0, r.length) > e && (r = r.substring(0, Math.max(0, e - u.length)), f && (r = r.trim()), r += u), r;
}
export {
  a as default
};
